export default __webpack_public_path__ + "static/media/person.596cc6de.jpg";